__webpack_require__.p = "https://wscdn.brandglpy.com/static/pay-checkout-web/";